import { render, staticRenderFns } from "./marital-status.vue?vue&type=template&id=12239a00"
import script from "./marital-status.vue?vue&type=script&lang=js"
export * from "./marital-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports